// FETCH ORDERS TYPES

export enum OrdersExcelActionTypes {
  FETCH_ORDERS_EXCEL_SAGA = "FETCH_ORDERS_EXCEL_SAGA",
  FETCH_ORDERS_EXCEL_SUCCESS = "FETCH_ORDERS_EXCEL_SUCCESS",
  FETCH_ORDERS_EXCEL_ERROR = "FETCH_ORDERS_EXCEL_ERROR",
  RESET_ORDERS_EXCEL = "RESET_ORDERS_EXCEL",
}
